import { useMemo } from 'react';
import * as yup from 'yup';

const useMeteocontrolFormValidationSchema = () =>
	useMemo(
		() =>
			yup.object({
				meteocontrolKeys: yup
					.array()
					.of(
						yup.object().shape({
							value: yup.string(),
							label: yup.string(),
						}),
					)
					.nullable(),
			}),
		[],
	);

export default useMeteocontrolFormValidationSchema;
